import { SpeakerXMarkIcon } from '@heroicons/react/24/outline'
import { ContentAction, ContentActionView, ContentView } from '../../../api/client'
import ActionGenericButton from './GenericActionButton'

type Props = {
    content: ContentView
    onActionClick: (actions: ContentActionView[], queued?: boolean) => void
    actions: ContentActionView[]
    disabled?: boolean
    disabledMessage?: string
}

export default function MuteButton(props: Props) {
    const { content, onActionClick, actions, disabled, disabledMessage } = props

    return (
        <ActionGenericButton
            content={content}
            onActionClick={onActionClick}
            action={ContentAction.Mute}
            tooltip="Mute/unmute this user"
            colour="yellow"
            icon={<SpeakerXMarkIcon />}
            actions={actions}
            disabled={disabled}
            disabledMessage={disabledMessage}
        />
    )
}
